var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-radio-list',{attrs:{"values":_vm.yesNoNot,"title":_vm.title,"model":_vm.model,"tooltip":_vm.tooltip,"disabled":_vm.checkDisabled()}})}
var staticRenderFns = []

export { render, staticRenderFns }